import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2, XCircle } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResumePayment() {
  const [params] = useSearchParams();
  const id = params.get("id");
  const [error, setError] = useState("");
  const { t } = useLang();

  useEffect(() => {
    if (!id) { setError("Lien invalide."); return; }
    axios.post(`${API}/payments/resume`, { registration_id: id, origin_url: window.location.origin })
      .then(({ data }) => { window.location.href = data.checkout_url; })
      .catch((e) => setError(e.response?.data?.detail || "Impossible de reprendre le paiement."));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center border border-[#27272A] bg-[#121214] p-12">
        <img src="/assets/logo-dark-sm.png" alt="D2R" className="h-12 w-auto mx-auto mb-10" />
        {!error ? (
          <>
            <Loader2 size={36} className="animate-spin text-[#C5A059] mx-auto" />
            <h1 className="font-display text-2xl uppercase font-bold mt-8" data-testid="resume-loading">{t("resume.loading")}</h1>
          </>
        ) : (
          <>
            <XCircle size={36} className="text-[#71717A] mx-auto" />
            <h1 className="font-display text-2xl uppercase font-bold mt-8" data-testid="resume-error">{error}</h1>
            <Link to="/" className="inline-block mt-8 border border-[#C5A059] text-[#C5A059] px-8 py-3.5 text-xs uppercase tracking-[0.25em] hover:bg-[#C5A059] hover:text-black transition-colors">
              {t("pay.back")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
